import _ from 'underscore';
import Backbone from 'backbone';

export var SecureSMSModel = Backbone.Model.extend({
  url: 'mfa/authenticate',

  defaults: function () {
    return {
      resultCode: null,
      resultText: '',
      isSuccess: false,
      isSent: false,
      phoneNumber: '등록하신 휴대폰 번호',
      isReady: false,
      type: 'SMS',
      code: ''
    };
  },

  initialize: function () {},

  parse: function (res) {
    return res.result;
  },

  sendSMS: function () {
    this.url = 'mfa/send-sms';
    this.save();
  },

  reset: function () {
    this.set(this.defaults());
  },

  authenticate: function (val) {
    if (!val || !$.trim(val) || !this.get('isReady')) {
      console.info('Not a valid SMS code.');
      return;
    }

    this.url = 'mfa/authenticate';
    this.save({
      code: $.trim(val)
    })
      .then(_.bind(this.parse, this))
      .then(
        _.bind(function () {
          this.trigger('sync:auth');
        }, this)
      );
  }
});
